export default (params) => ({
  trigger: {
    name: 'product_type_section.open_product_summary',
    params: params,
  },
  config: {
    schema: {
      sub_feature: {
        enum: [
          'product_type_section',
          'product_type_section_alternative_overlay',
        ],
      },
    },
    event: {
      name: 'select_content',
      params: {
        content: 'product_summary_overlay',
      },
    },
  },
});
